import {BetragPipe} from '../../pipes/simple/betrag.pipe';
import {HandelsangabenDetailEntryMeta} from '../../../core/gb-api';
import {Pipe} from "@angular/core";
import {KompaktdarstellungPipe} from "../kompakt-darstellung.pipe";
import {FormatConfigService} from "../../../core/services/format-config.service";
import {PlatformLocation} from "@angular/common";
import {ComponentLocationStrategy} from "../../services/location-strategy/component-location-strategy";
import {FormatConfigEntry} from "../../../core/base-api";
import {keysToTranslate} from 'i18n/keys-to-translate';
import {DecimalHochkommaPipe} from '../../pipes/simple/decimalHochkomma.pipe';

@Pipe({
  name: 'kompaktHandelsangaben'
})
export class KompaktHandelsangabenPipe extends KompaktdarstellungPipe<HandelsangabenDetailEntryMeta> {

  constructor(protected formatConfigService: FormatConfigService,
              protected location: PlatformLocation,
              protected kompaktLocation: ComponentLocationStrategy,
              private betragPipe: BetragPipe,
              private hochkommaPipe: DecimalHochkommaPipe
  ) {
    super(formatConfigService, 'HANDELSANGABEN', location, kompaktLocation);
    keysToTranslate<any>([]);
  }

  transform(entry: HandelsangabenDetailEntryMeta, type: FormatConfigEntry.ElementEnum = this.formatElement, languageChangeEvent = 'de'): string {
    if (!entry) {
      return;
    }
    let value = "";
    if (type === 'HANDELSANGABEN_TYP00') {
      const dataArray = [this.preis(entry), this.flaeche(entry), this.quote(entry), this.bemerkung(entry)];
      value = dataArray.filter(Boolean).join(", ");
    }
    return value;
  }

  bemerkung(entry: HandelsangabenDetailEntryMeta): string {
    if (entry.bemerkungen) {
      return entry.bemerkungen;
    } else {
      return '';
    }
  }


  preis(entry: HandelsangabenDetailEntryMeta): string {
    if (entry.preis) {
      return this.betragPipe.transform(entry.preis);
    } else {
      return '';
    }
  }

  flaeche(entry: HandelsangabenDetailEntryMeta): string {
    if (entry.flaecheQuadratmeter) {
      return this.hochkommaPipe.transform(entry.flaecheQuadratmeter) + " m²";
    } else {
      return '';
    }
  }

  quote(entry: HandelsangabenDetailEntryMeta): string {
    let res = "";
    if (this.displayQuote(entry)) {
      res = entry.quote.zaehler + "/" + entry.quote.nenner;
    }
    return res;
  }

  private displayQuote(entry: HandelsangabenDetailEntryMeta): boolean {
    if (!entry.quote) {
      return false;
    }
    if (entry.quote.zaehler === 1 && entry.quote.nenner === 1) {
      return false;
    }
    return !(entry.quote.zaehler === 0 && entry.quote.nenner === 0);
  }

}
